export function Modules() {
  return (
    <div className="w-full max-w-6xl mx-auto my-16 px-6">
      <h2 className="text-3xl font-bold text-center mb-4">PRODUCTION MODULES</h2>
      <p className="text-gray-600 text-center mb-12 max-w-2xl mx-auto">
        Comprehensive suite of modules that automate and optimize your entire manufacturing workflow
      </p>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {modules.map((module, i) => (
          <div
            key={i}
            className="bg-white rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2 border border-gray-100 overflow-hidden group"
          >
            <div className="h-48 overflow-hidden">
              <img
                src={module.icon}
                alt={module.title}
                className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-300"
              />
            </div>
            <div className="p-6">
              <div className="flex items-center mb-3">
                <div className="w-10 h-10 bg-blue-100 rounded-lg flex items-center justify-center mr-3">
                  <span className="text-blue-600 font-bold text-lg">{i + 1}</span>
                </div>
                <h3 className="text-xl font-bold text-gray-800">{module.title}</h3>
              </div>
              <p className="text-gray-600 leading-relaxed">{module.desc}</p>
              <div className="mt-4 flex flex-wrap gap-2">
                {module.features.map((feature, idx) => (
                  <span
                    key={idx}
                    className="text-xs bg-gray-100 text-gray-700 px-2 py-1 rounded-full"
                  >
                    {feature}
                  </span>
                ))}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

// Smart Production Modules
const modules = [
  {
    title: "Operator Management",
    desc: "Track operator activities, assign tasks, and monitor performance in real-time with digital work instructions.",
    icon: "/images/production/operator-tracking.jpg",
    features: ["Task Assignment", "Performance Tracking", "Digital Work Orders"]
  },
  {
    title: "Machine Monitoring",
    desc: "Real-time machine performance tracking with automated stoppage alerts and OEE calculations.",
    icon: "/images/production/machine-monitoring.jpg",
    features: ["OEE Tracking", "Stoppage Alerts", "Performance Analytics"]
  },
  {
    title: "Quality Control",
    desc: "Digital quality inspections, defect tracking, and comprehensive quality assurance documentation.",
    icon: "/images/production/quality-control.jpg",
    features: ["Digital Checklists", "Defect Tracking", "Quality Reports"]
  },
  {
    title: "Production Planning",
    desc: "Schedule production orders, allocate resources, and optimize manufacturing workflows.",
    icon: "/images/production/production-planning.svg",
    features: ["Scheduling", "Resource Allocation", "Workflow Optimization"]
  },
  {
    title: "Maintenance Management",
    desc: "Preventive maintenance scheduling, issue tracking, and downtime management for maximum uptime.",
    icon: "/images/production/production-planning.svg",
    features: ["Preventive Maintenance", "Issue Tracking", "Downtime Analysis"]
  },
  {
    title: "ERP Integration",
    desc: "Seamless bidirectional data synchronization with your backend ERP system for real-time updates.",
    icon: "/images/production/erp-integration.png",
    features: ["Real-time Sync", "Data Accuracy", "Process Automation"]
  }
];